module.exports = __webpack_public_path__ + "img/jiadian.dd7126ba.png";